import { getTokenDetail } from "api/api";

export const FETCH_PROFILE_REQUEST = "FETCH_PROFILE_REQUEST";
export const FETCH_PROFILE_RECEIVED = "FETCH_PROFILE_RECEIVED";
export const FETCH_PROFILE_ERROR = "FETCH_PROFILE_ERROR";

const fetchProfileRecieved = (data) => {
  return {
    type: FETCH_PROFILE_RECEIVED,
    data: data,
  };
};

const fetchProfileError = (error) => {
  return {
    type: FETCH_PROFILE_ERROR,
    error: error,
  };
};

export const fetchProfileData = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_PROFILE_REQUEST });

      const response = await getTokenDetail(`0x${parseInt(id).toString(16)}`);
      dispatch(fetchProfileRecieved(response.data));
    } catch (error) {
      dispatch(fetchProfileError(error));
    }
  };
};
